// @ts-nocheck
if (!window.videoObserver) {
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')

  function shouldAutoplay(video) {
    return video.dataset.userPaused !== '1' && video.dataset.autoplay !== 'false'
  }

  function shouldAvoidAutomaticLoad(video) {
    if (video.dataset.userInitiated === '1' || !shouldAutoplay(video)) return false
    return navigator.connection?.saveData === true || reducedMotionQuery.matches
  }

  function setInView(video, inView) {
    if (inView) video.dataset.inView = '1'
    else delete video.dataset.inView
  }

  function tryPlay(video) {
    if (shouldAvoidAutomaticLoad(video) || !shouldAutoplay(video) || video.dataset.inView !== '1' || !video.paused) return
    const playPromise = video.play()
    if (playPromise) playPromise.catch(() => {})
  }

  function markVideoReady(video) {
    video.classList.remove('blur-sm', 'opacity-0')
    video.dataset.videoState = 'ready'
    const poster =
      video.parentElement?.querySelector('[data-video-poster]') ||
      video.closest('[data-video-wrapper]')?.querySelector('[data-video-poster]')
    if (poster) poster.style.opacity = '0'
    tryPlay(video)
  }

  function loadVideo(video) {
    if (video.dataset.videoLoaded === '1') return

    const hasSource = Boolean(video.querySelector('source'))
    const srcs = hasSource ? [] : JSON.parse(video.getAttribute('data-srcs') || '[]')
    if (!hasSource && !srcs.length) return

    video.dataset.videoLoaded = '1'

    if (video.readyState >= 2) {
      markVideoReady(video)
    } else {
      video.addEventListener('canplay', () => markVideoReady(video), { once: true })
    }

    if (!hasSource) {
      srcs.forEach((src) => {
        const source = document.createElement('source')
        source.setAttribute('type', src.type)
        source.setAttribute('src', src.src)
        video.appendChild(source)
      })
      video.load()
    } else if (video.readyState === 0) {
      video.load()
    }
  }

  function loadAfterPageIdle(video) {
    if (video.dataset.videoLoadReady === '1') {
      loadVideo(video)
      return
    }
    if (video.dataset.videoLoadScheduled === '1') return

    video.dataset.videoLoadScheduled = '1'

    const markReady = () => {
      video.dataset.videoLoadReady = '1'
      if (video.dataset.inView !== '1' || video.dataset.userPaused === '1') return
      loadVideo(video)
      tryPlay(video)
    }

    const waitForIdle = () => {
      window.setTimeout(() => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(markReady, { timeout: 2000 })
        } else {
          window.setTimeout(markReady, 500)
        }
      }, 750)
    }

    if (document.readyState === 'complete') waitForIdle()
    else window.addEventListener('load', waitForIdle, { once: true })
  }

  function requestVideoLoad(video) {
    if (shouldAvoidAutomaticLoad(video)) return
    if (video.dataset.videoLoadStrategy === 'after-load-idle') {
      loadAfterPageIdle(video)
    } else {
      loadVideo(video)
    }
  }

  function observeVideo(video) {
    video.loadVideo = () => loadVideo(video)
    if (window.videoObserver && !video.dataset.videoObserved) {
      video.dataset.videoObserved = '1'
      window.videoObserver.observe(video)
    }
  }

  window.observeLazyVideo = observeVideo

  window.videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target
        const inView = entry.intersectionRatio >= 0.5
        setInView(video, inView)

        if (!inView) {
          if (!video.paused) video.pause()
          return
        }

        if (video.dataset.userPaused === '1') return
        requestVideoLoad(video)
        tryPlay(video)
      })
    },
    { threshold: [0.1, 0.25, 0.5, 0.75, 0.9] }
  )

  const $$videos = document.querySelectorAll('[data-lazy-video]')
  $$videos.forEach(observeVideo)
  document.dispatchEvent(new CustomEvent('lazyvideo:ready'))

  document.addEventListener('shopify:section:load', (e) => {
    const sectionId = e.detail?.sectionId
    if (!sectionId) return
    const container = document.querySelector(`#shopify-section-${sectionId}`) || document.querySelector(`[data-section-id="${sectionId}"]`)?.closest('.shopify-section')
    if (container) {
      container.querySelectorAll('[data-lazy-video]').forEach(observeVideo)
    }
  })

  document.addEventListener('shopify:section:unload', (e) => {
    const sectionId = e.detail?.sectionId
    if (!sectionId) return
    const container = document.querySelector(`#shopify-section-${sectionId}`) || document.querySelector(`[data-section-id="${sectionId}"]`)?.closest('.shopify-section')
    if (container) {
      container.querySelectorAll('[data-lazy-video]').forEach((video) => {
        if (video.dataset.videoObserved) {
          delete video.dataset.videoObserved
          window.videoObserver?.unobserve(video)
        }
      })
    }
  })
}
